'use client'

import { HTMLProps } from 'react'
import clsx from 'classnames'
import { useLocale } from 'use-intl'
import { useTimeLineCarousel } from '@/shared/ui/timeline/hooks'
import { langDir } from '@/shared/utils/directus'
import { IHistoryPoint } from '@/interfaces/blocks'
import { TimelineItem } from './timeline-item'
import { TimelineThumbs } from './timeline-thumbs'
import { TimelineNavigation } from './timeline-navigation'
import style from './timeline.module.scss'

interface TimelineProps extends HTMLProps<HTMLDivElement> {
  items: IHistoryPoint[]
}

export const Timeline = (props: TimelineProps) => {
  const { className, items } = props
  const currentLocale = useLocale()
  const direction = (langDir[currentLocale] ?? 'ltr') as 'ltr' | 'rtl'
  const { onThumbClick, emblaThumbsRef, emblaMainRef, onNextButtonClick, onPrevButtonClick, selectedIndex } =
    useTimeLineCarousel(`.${style.slides}`, direction)

  return (
    <section ref={emblaMainRef} className={clsx(style.container, className)}>
      <TimelineThumbs onThumbClick={onThumbClick} items={items} selectedIndex={selectedIndex} ref={emblaThumbsRef} />

      <ul className={clsx(style.slides)}>
        {items.map(item => (
          <TimelineItem
            key={item.year}
            {...item}
            navigation={
              <TimelineNavigation onNextButtonClick={onNextButtonClick} onPrevButtonClick={onPrevButtonClick} />
            }
          />
        ))}
      </ul>
    </section>
  )
}
